<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    id="OffcanvasForm"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ $t('Finalize Close Shift') }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="d-flex justify-content-between">
          <div>
            <b style="font-size: 18px;" class="mt-2 me-1">
              {{ data.branch }}
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
            </div>
          </div>
        </div>
      </div>
      <div class="m-3">
        <div class="row g-3">
          <div class="col-md-4">
            <div
              class="card h-100"
            >
              <div class="card-header">
                <b>
                  {{ $t('System Expectation') }}
                </b>
              </div>
              <div class="card-body">
                <div class="gx-0 row">
                  <div class="col-md-12">
                    <div
                      class="card bg-secondary-subtle"
                    >
                      <div class="card-body text-center">
                        {{ $t('Expected Cash in Drawer') }}
                        <h4>
                          {{ $storeIndex.formatThaiCurrency(expectedCash) }}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      <i class='fas fa-money-bill-wave me-1 text-secondary'/>
                      {{ $t('Starting Cash') + ':' }}
                    </span>
                    <span>
                      {{ '+' + $storeIndex.formatThaiCurrency(data.starting_cash) }}
                    </span>
                  </div>
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      <i class='fas fa-cash-register me-1 text-secondary'/>
                      {{ $t('Total Cash Sales') + ':' }}
                    </span>
                    <span>
                      {{ '+' + $storeIndex.formatThaiCurrency(data.total_cash_sales) }}
                    </span>
                  </div>
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      <i class='fas fa-arrow-down me-1 text-secondary'/>
                      {{ $t('Total Pay In') + ':' }}
                    </span>
                    <span>
                      {{ '+' + $storeIndex.formatThaiCurrency(data.total_pay_in) }}
                    </span>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-between mt-2 text-danger pb-1"
                  >
                    <span>
                      <i class='fas fa-arrow-up me-1 text-secondary'/>
                      {{ $t('Total Pay Out/Refunds') + ':' }}
                    </span>
                    <span>
                      {{ '-' + $storeIndex.formatThaiCurrency(parseFloat(data.total_pay_out)+parseFloat(data.total_refund)) }}
                    </span>
                  </div>
                  <div
                    v-if="form.actual_cash !== ''"
                    class="col-md-12 mt-2"
                  >
                    <div
                      v-if="form.actual_cash < expectedCash"
                      class="bg-danger card text-white"
                    >
                      <div class="card-body p-2 text-center">
                        <h6 class="m-0">
                          {{ $t('Difference') + ': -'+$storeIndex.formatThaiCurrency(expectedCash-form.actual_cash)+' (' + $t('Short') + ')'  }}
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="form.actual_cash > expectedCash"
                      class="bg-info card"
                    >
                      <div class="card-body p-2 text-center">
                        <h6 class="m-0">
                          {{ $t('Difference') + ': +'+$storeIndex.formatThaiCurrency(form.actual_cash-expectedCash)+' (' + $t('Over') + ')'  }}
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else
                      class="bg-success card"
                    >
                      <div class="card-body p-2 text-center">
                        <h6 class="m-0">
                          {{ $t('Difference') + ': ฿0.00 (' + $t('Match') + ')'  }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div
              class="card"
            >
              <div class="card-header">
                <b>
                  {{ $t('Actual Totals Verification') }}
                </b>
              </div>
              <div class="card-body">
                <div class="row gx-0">
                  <div class="col-md-12">
                    <h5>
                      <b>
                        {{ '1. ' + $t('Cash') }}
                      </b>
                    </h5>
                  </div>
                  <div class="col-md-12">
                    <div class="d-flex justify-content-between">
                      <label
                        for="actual_cash"
                        class="form-label"
                      >
                        {{ $t('Total Cash Counted') + ':' }}
                      </label>
                      <span
                        class="align-content-center text-danger"
                        style="font-size: 13px;"
                        v-if="form.actual_cash !== '' && (form.actual_cash < expectedCash)"
                      >
                        <i class='fas fa-times-circle'/>
                        {{ $t('Short') + ' ('+$t('System')+': ' + $storeIndex.formatThaiCurrency(expectedCash) + ')' }}
                      </span>
                      <span
                        class="align-content-center text-info"
                        style="font-size: 13px;"
                        v-else-if="form.actual_cash !== '' && (form.actual_cash > expectedCash)"
                      >
                        <i class='fas fa-circle-info'/>
                        {{ $t('Over') + ' ('+$t('System')+': ' + $storeIndex.formatThaiCurrency(expectedCash) + ')' }}
                      </span>
                      <span
                        class="align-content-center text-secondary"
                        style="font-size: 13px;"
                        v-else-if="form.actual_cash !== ''"
                      >
                        <i class='fas fa-circle-check'/>
                        {{ $t('Match') + ' ('+$t('System')+': ' + $storeIndex.formatThaiCurrency(expectedCash) + ')' }}
                      </span>
                    </div>
                    <div class="input-group-sm">
                      <input
                        id="actual_cash"
                        style="font-size: 16px;"
                        v-model.trim="v$.form.actual_cash.$model"
                        :placeholder="'0.00'"
                        type="number"
                        inputmode="numeric"
                        class="form-control shadow-none text-end"
                      >
                      <div
                        class="d-flex"
                      >
                        <div v-for="error of v$.form.actual_cash.$errors"
                          class="d-block invalid-feedback"
                          :key="error.$uid"
                        >
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="otherPayments.length">
                    <hr class="mt-3">
                    <div class="col-md-12">
                      <h5>
                        <b>
                          {{ '2. ' + $t('Other Payments') }}
                        </b>
                        <span class="ms-1 text-secondary" style="font-size: 13px;">
                          {{ '(' + $t('Optional') + ' — ' + $t('Leave blank if not verified yet') + ')' }}
                        </span>
                      </h5>
                    </div>
                    <div
                      class="col-md-12 mb-3"
                      v-for="payment in otherPayments"
                      :key="payment.branch_payment_method_id || ('method-' + payment.payment_method_id)"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          :for="'actual_' + payment.branch_payment_method_id"
                          class="form-label"
                        >
                          {{ $t(payment.label) + ':' }}
                        </label>
                        <span
                          class="align-content-center text-danger"
                          style="font-size: 13px;"
                          v-if="isCounted(payment) && (form.payments[payment.branch_payment_method_id] < parseFloat(payment.expected_amount))"
                        >
                          <i class='fas fa-times-circle'/>
                          {{ $t('Short') + ' ('+$t('System')+': ' + $storeIndex.formatThaiCurrency(payment.expected_amount) + ')' }}
                        </span>
                        <span
                          class="align-content-center text-info"
                          style="font-size: 13px;"
                          v-else-if="isCounted(payment) && (form.payments[payment.branch_payment_method_id] > parseFloat(payment.expected_amount))"
                        >
                          <i class='fas fa-circle-info'/>
                          {{ $t('Over') + ' ('+$t('System')+': ' + $storeIndex.formatThaiCurrency(payment.expected_amount) + ')' }}
                        </span>
                        <span
                          class="align-content-center text-secondary"
                          style="font-size: 13px;"
                          v-else-if="isCounted(payment)"
                        >
                          <i class='fas fa-circle-check'/>
                          {{ $t('Match') + ' ('+$t('System')+': ' + $storeIndex.formatThaiCurrency(payment.expected_amount) + ')' }}
                        </span>
                        <span
                          class="align-content-center text-secondary"
                          style="font-size: 13px;"
                          v-else
                        >
                          {{ $t('System') + ': ' + $storeIndex.formatThaiCurrency(payment.expected_amount) }}
                        </span>
                      </div>
                      <div class="input-group-sm">
                        <input
                          v-if="payment.branch_payment_method_id"
                          :id="'actual_' + payment.branch_payment_method_id"
                          style="font-size: 16px;"
                          v-model.trim="form.payments[payment.branch_payment_method_id]"
                          :placeholder="$t('Not Counted')"
                          type="number"
                          inputmode="numeric"
                          class="form-control shadow-none"
                        >
                        <input
                          v-else
                          :value="$storeIndex.formatThaiCurrency(payment.sales_amount)"
                          style="font-size: 16px;"
                          type="text"
                          class="form-control shadow-none"
                          disabled
                        >
                      </div>
                    </div>
                  </template>
                  <hr class="mt-3">
                  <div class="col-md-12">
                    <label for="note" class="form-label">
                      {{ $t('Note') }}
                    </label>
                    <textarea
                      class="form-control shadow-none"
                      id="note"
                      v-model.trim="v$.form.note.$model"
                      style=" font-size: 14px;"
                      :placeholder="$t('note') + '...'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission"
    >
      <ladda
        text="Close Shift"
        :btn-class="'btn btn-danger btn-block '"
        :loading="loadingSave"
        :disabled="v$.$invalid"
        @click="handleCloseShift"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-close";
import { POSRegisters } from '@/services/endpoint/pos.service';
import moment from "moment";
import { useScrollRestore } from '@/composables/useScrollRestore';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    let vm = this;
    return {
      loading: true,
      hasPermission: false,
      loadingSave: false,
      data: {},
      expectedCash: 0,
      form: {
        actual_cash: '',
        // ยอดยืนยันช่องทางอื่น เก็บเป็น map ตาม branch_payment_method_id (ช่องทางต่างกันในแต่ละสาขา)
        payments: {},
        note: ''
      }
    }
  },
  components: {
    PlaceholderContent,
    Ladda,
    AccessDenied,
  },
  methods: {
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    async fetchData() {
      await POSRegisters.getCloseShift(this.id).then(res => {
        this.data = res.data.data;
        // เงินสดคาดหวังคำนวณจาก server (ทุน + ขายสด + รับเข้า − จ่ายออก − คืนเงินสด)
        this.expectedCash = parseFloat(this.data.expected_cash);
        this.hasPermission = true;
      }).catch(err => {
        this.hasPermission = false;
        this.loading = false;
			  throw err;
      });
    },
    isCounted(payment) {
      let value = this.form.payments[payment.branch_payment_method_id];
      return value !== undefined && value !== null && value !== '';
    },
    setParamsBeforeSendCloseShift() {
      // ประกอบ payload เอง — ส่งเฉพาะช่องทางที่พนักงานกรอกจริง (ที่เว้นว่าง = ไม่ได้นับ)
      let params = {
        actual_cash: this.form.actual_cash
      };

      let payments = this.otherPayments
        .filter(payment => payment.branch_payment_method_id && this.isCounted(payment))
        .map(payment => ({
          branch_payment_method_id: payment.branch_payment_method_id,
          actual_amount: this.form.payments[payment.branch_payment_method_id]
        }));

      if (payments.length) params.payments = payments;
      if (this.form.note) params.note = this.form.note;

      return params;
    },
    async handleCloseShift() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      try {
        let self = this;
        let title = this.$t("Confirm Close Shift") + '?';
        let text = this.$t('Please verify the actual cash counted and other payment totals. Closing the shift will finalize the Z-Report and this action cannot be undone.');
        let confirmButtonText = '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          text: text,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return POSRegisters.closeShift(self.id, self.setParamsBeforeSendCloseShift())
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Close Shift Success!'));
                $(self.$refs.offcanvas).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        }).then((res) => {
          this.loadingSave = false;
        });
      } catch (error) {
        this.loadingSave = false;
      }
    }
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        await this.fetchData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });

    useScrollRestore(() => this.$refs.offcanvas?.querySelector('.offcanvas-body'));
  },
  computed: {
    // ช่องทางที่ไม่ใช่เงินสด เฉพาะที่สาขานี้เปิดใช้จริง (ส่วนต่างคำนวณที่ server)
    // ช่องทางที่ไม่มี branch_payment_method_id = ข้อมูลเก่าที่อ้างช่องทางไม่ได้ → ดูได้อย่างเดียว
    otherPayments() {
      return (this.data.payments ?? []).filter(payment => !payment.is_cash);
    }
  },
  watch: {
  }
}
</script>
